import Vue from 'vue';
import Vuex, { StoreOptions, Store } from 'vuex';
import { Location as RouterLocation} from 'vue-router';
import i18n from './i18n';
import $ from 'jquery';

Vue.use(Vuex);

const FIXMEtranslations: { [key: string]: { [key: string]: string} } = { // FIXME get from database
    en: {
        titleConfigurator: 'Configurator',
        title: 'Configurator',
        progressProductsCount: 'No product | {count} possible product | {count} possible products',
        progressTotal: '{0}% completed',
        buttonNext: 'next',
        linkStartAnew: 'New configuration',
        linkToConfigurator: 'back to configurator',
        linkSendConfiguration: 'Send configuration',
        linkDatasheet: 'Datasheet',
        linkCompare: 'Compare products',
        linkToProduct: 'back to selection',
        linkReset: 'Reset',
        productDetails: 'Details',
        productAddCompare: 'Mark ({0})',
        productAccessories: 'Accessories',
        compareTitle: 'Compare products',
        compareProduct: 'Product',
        orderTitle: 'Inquiry',
        orderButton: 'Send Request',
        orderDetails: 'Order No. / Details',
        orderSender: 'Sender information',
        orderCompany: 'Company',
        orderDepartment: 'Department',
        orderFirstname: 'First name',
        orderLastname: 'Last name',
        orderStreetAddress: 'Street and P.O. Box',
        orderZIP: 'Zip Code',
        orderCity: 'City',
        orderCountry: 'Country',
        orderPhone: 'Phone',
        orderFax: 'Fax',
        orderMailaddress: 'E-mail',
        orderRequiredFields: 'mandatory fields',
        orderPrivacyNotice: `<strong>Data protection notice</strong> - The information you transmit to us, e.g. name,
address and phone number, will be processed by us for no other purpose than for taking up direct contact to you or
for any other purpose for which you transmit your data to us. At any time you can revoke the right to use the data.
After the expiry of the fixed purpose, we will delete your data in accordance with the requirements of the Federal
Data Protection Act unless it is subject to a statutory retention period. For more detailed information or if you
have any further questions, please contact our data protection officer Mrs Kerstin Blossey
<a href="mailto:dataprotection@bartec.de">dataprotection@bartec.de</a>.`,
        orderCaptcha: 'Security question: How many corners has the {0} marking?',
        sentTitle: 'Thank you for your request!',
        sentCopytext: 'Thanks for using our configuration tool, our local sales support team will come back to you.',
        validateRequired: 'mandatory field',
        validateCaptcha: 'You must answer the securtiy questions correctly',
        validateAttribute: 'You must choose an option',
        notAvailable: 'n/a',
        comingSoon: 'coming soon!',
        productLink: 'Product page',
        showMoreCollapsed: 'Show more…',
        showMoreExpanded: 'Show less…',
        reloadingDueToDataChange: 'Update of product data detected. Restarting the configurator!',
        pleaseSelect: '---',
    },
    de: {
        titleConfigurator: 'Konfigurator',
        title: 'Konfigurator',
        progressProductsCount: 'Kein Produkte zur Auswahl | {count} Produkt zur Auswahl | {count} Produkte zur Auswahl',
        progressTotal: '{0}% geschafft',
        buttonNext: 'weiter',
        linkStartAnew: 'Neue Konfiguration',
        linkToConfigurator: 'zurück zum Konfigurator',
        linkSendConfiguration: 'Konfiguration senden',
        linkDatasheet: 'Datenblatt',
        linkCompare: 'Produktvergleich',
        linkToProduct: 'zurück zur Auswahl',
        linkReset: 'Zurücksetzten',
        productDetails: 'Details',
        productAddCompare: 'Merken ({0})',
        productAccessories: 'Zubehör',
        compareTitle: 'Produktvergleich',
        compareProduct: 'Produkt',
        orderTitle: 'Anfrage',
        orderButton: 'Anfrage senden',
        orderDetails: 'Bestellnummer / Details',
        orderSender: 'Absender-Informationen',
        orderCompany: 'Firma',
        orderDepartment: 'Abteilung',
        orderFirstname: 'Vorname',
        orderLastname: 'Nachname',
        orderStreetAddress: 'Straße, Nr.',
        orderZIP: 'PLZ',
        orderCity: 'Ort',
        orderCountry: 'Land',
        orderPhone: 'Telefon',
        orderFax: 'Telefax',
        orderMailaddress: 'E-Mail',
        orderRequiredFields: 'Pflichtfelder',
        orderPrivacyNotice: `<strong>Datenschutzhinweis</strong> - Die Informationen, die Sie uns hiermit übermitteln,
zum Beispiel Name, Anschrift und Telefonnummer, verarbeiten wir ausschließlich zum Zwecke der direkten Kontaktaufnahme
mit Ihnen oder dem sonstigen Zweck, zu dem Sie uns Ihre Daten bekannt geben. Sie können der Datennutzung jederzeit
widersprechen.
Nach Wegfall der Zweckbestimmung löschen wir Ihre Daten nach den Erfordernissen des Bundesdatenschutzgesetzes, sofern
diese keiner gesetzlichen Aufbewahrungsfrist unterliegen. Für weitere Informationen oder eventuelle Rückfragen steht
Ihnen unsere Datenschutzbeauftragte Kerstin Blossey unter
<a href="mailto:dataprotection@bartec.de">dataprotection@bartec.de</a> gerne zur Verfügung.`,
        orderCaptcha: 'Sicherheitsabfrage: Wie viele Ecken hat das {0} Zeichen?',
        sentTitle: 'Vielen Dank für Ihre Anfrage!',
        sentCopytext: 'Danke, dass Sie unseren Konfigurator benutzt haben, unser Vertriebsunterstützungsteam ' +
            'wird sich bei ihnen melden',
        validateRequired: 'Pflichtfeld',
        validateCaptcha: 'Die Sicherheitsabfrage muss korrekt beantworted werden',
        validateAttribute: 'Eine Option muss gewählt werden',
        notAvailable: 'n. a.',
        comingSoon: 'bald verfügbar!',
        productLink: 'Produktseite',
        showMoreCollapsed: 'Zeige mehr…',
        showMoreExpanded: 'Zeige weniger…',
        reloadingDueToDataChange: 'Die Produktdaten wurden aktualisert. Neustart des Konfigurators ist nötig!',
        pleaseSelect: '---',
    },
};

function initPages(data: any) {
    data.pages.forEach((page: any, index: number) => {
        page.n = 0;
        page.location = {};
        page.isComplete = false;
        page.isAutoComplete = false;
        page.isActive = false;
        page.isEnabled = false;
        page.attributes.forEach((attribute: any, jndex: number) => {
            attribute.index = 0;
            attribute.disabled = true;
            attribute.indicator = false;
            attribute.value = '';
            attribute.isComplete = false;
            attribute.hasSingleOption = null;
            attribute.pageN = 0;
            attribute.options.forEach((option: any) => {
                option.disabled = true;
            });
            attribute.restrictVersion = -1;
            attribute.isValueByUser = false;
        });
    });
}

function initState(state: AppState) {
    let indexCounter = 0;
    state.pages.forEach((page, index) => {
        page.n = index + 1;
        page.location = { name: 'page', params: {n: String(page.n)}};
        page.isComplete = false;
        page.isAutoComplete = false;
        page.attributes.forEach((attribute, jndex) => {
            attribute.index = indexCounter++;
            attribute.disabled = true;
            attribute.indicator = false;
            attribute.value = '';
            attribute.isComplete = false;
            attribute.hasSingleOption = null;
            attribute.pageN = page.n;
            attribute.options.forEach((option) => {
                option.disabled = true;
            });
            state.attributes.push(attribute);
            attribute.restrictVersion = -1;
            attribute.isValueByUser = false;
        });
    });
}

function updatePages(state: AppState, activate: number = 0) {
    activate = activate || 0;
    let activePage = null;
    let lastPage: PageDef | null = null;
    state.pages.forEach((page) => {
        page.isActive = (page.n === activate);
        page.isEnabled = (!lastPage || lastPage.isComplete);
        if (page.isActive) {
            activePage = page;
        }
        lastPage = page;
        return page;
    });
    Vue.set(state, 'page', activePage);
    if (state.page) {
        if (!state.maxPage || state.page.n > state.maxPage.n) {
            state.maxPage = state.page;
        }
    }
}

function updateProgress(state: AppState) {
    // FIXME progress
    const i = (state.page && (state.page.n - 1)) || 0;
    state.progress = i / state.pages.length;
}

function fakeInit(state: AppState) {
    /* FIXME faked initial data
    const product = {
        id: '2186969',
        name: 'Productname:2186969',
        options: {
            8607: 31914,
            8608: 31917,
            8609: 31920,
            8610: 31923,
            8611: 31933,
            8612: 31935,
            8613: 31945,
            8614: 31949,
            8615: 31961,
            8616: 31964,
            8617: 31966,
            8618: 31968,
            8619: 31972,
            8620: 31974,
            8621: 31980,
            8622: 31986,
            8623: 31989,
            8624: 32002,
            8625: 32008,
            8626: 32013,
            8627: 32016,
            8628: 32019,
            8629: 32023,
            8630: 32026,
            8631: 32028,
            8632: 32030,
            8633: 32033,
            8634: 32034,
            8635: 32036,
            8636: 32038,
            8637: 32042,
            8638: 32048,
            8639: 32053,
        },
        image: 'http://pimcore-base.code.test/Configurators/Products/product.jpg',
        datasheet: 'http://pimcore-base.code.test/Configurators/Products/datasheet.pdf',
    };
    state.product = product;
    state.productForOrder = product;
    state.compare = [product];
    state.pages.forEach((page, index) => {
        page.isComplete = (page.n < 5);
        if (page.isComplete) {
            page.attributes.forEach((attribute, jndex) => {
                attribute.disabled = false;
                attribute.options.forEach((option) => {
                    option.disabled = false;
                });
            });
        }
    });
    */
}

let rippleCounter = 1;
const restrictMultiCallCache: { [key: string]: JQuery.PlainObject } = {};

function restrictMultiCall(params: JQuery.PlainObject): JQuery.Promise<JQuery.PlainObject> {
    const data = JSON.stringify(params);

    if (restrictMultiCallCache[data]) {
        return $.Deferred().resolve(restrictMultiCallCache[data]).promise();
    } else {
        return $.post({
            url: './api/restrict-multi.json',
            data,
            contentType: 'application/json',
        }).then((result) => {
            restrictMultiCallCache[data] = result;
            return result;
        });
    }
}

const storeOption: StoreOptions<AppState> = {
    strict: process.env.NODE_ENV !== 'production', // only for debugging
    state: (() => {
        const state: AppState = {
            dataSetId: '-1',
            pages: [],
            page: null,
            maxPage: null,
            progress: 0,
            productsCount: 0,
            product: null,
            productForOrder: null,
            compare: [],
            customer: null,
            attributes: [],
            ajaxModal: false,
            flags: {},
            mode: (() => {
                if ($('body').is('.bartec-configurator-iframe')) {
                    return 'iframe';
                } else {
                    return 'standalone';
                }
            })(),
            restrictVersion: 0,
        };

        return state;
    })(),
    getters: {
        steps: (state) => {
            return state.pages;
        },
        homePage: (state) => {
            return state.pages[0];
        },
        isIframe: (state) => {
            return state.mode === 'iframe';
        },
    },
    mutations: {
        init(state, data) {
            state.pages = data.pages;
            state.flags = data.flags || {};
            state.dataSetId = String(data.dataSetId);
            initState(state);
            updatePages(state);
            updateProgress(state);
            fakeInit(state);
        },

        ajaxModal(state, { on }: { on: boolean}) {
            state.ajaxModal = !!on;
        },

        activatePage(state, { n }: { n: number}) {
            updatePages(state, n);
            updateProgress(state);
        },

        product(state, { product }: { product: ProductDef | null}) {
            state.product = product;
        },

        addCompareProduct(state, { product }: { product: ProductDef}) {
            const compareProduct = state.compare.find((p) => p.id === product.id);
            if (!compareProduct) {
                state.compare.push(product);
            }
        },

        removeCompareProduct(state, { product }: { product: ProductDef}) {
            const index = state.compare.findIndex((p) => p === product);
            if (index !== -1) {
                state.compare.splice(index, 1);
            }
        },

        productForOrder(state, { product }: { product: ProductDef}) {
            state.productForOrder = product;
        },

        order(state, {customer, product}: { customer: CustomerDef, product: ProductDef}) {
            state.customer = customer;
        },

        setAttribute(
            state,
            { attribute, value, disabled, isValueByUser, isComplete}:
                {
                    attribute: AttributeDef,
                    value: string, disabled: boolean,
                    isValueByUser: boolean,
                    isComplete: boolean | undefined,
                },
        ) {
            if (attribute.value !== value) {
                ++state.restrictVersion;
            }
            attribute.value = value;
            attribute.isComplete = isComplete || !!value;
            attribute.isValueByUser = isValueByUser && !!value;
            attribute.disabled = disabled;
            const page = state.pages.find((p) => p.n === attribute.pageN);
            if (page) {
                page.isComplete = true;
                page.attributes.forEach( (attr) => { page.isComplete = page.isComplete && attr.isComplete; });
            }
            updatePages(state, (state.page && state.page.n) || 0);
            updateProgress(state);
        },

        setIndicator(state, { attribute, indicator }: { attribute: AttributeDef, indicator: boolean }) {
            attribute.indicator = indicator;
        },

        updateSelect(
            state,
            { attribute, optionIds, restrictVersion}:
                { attribute: AttributeDef, optionIds: string[], restrictVersion: number },
        ) {
            let count = 0;
            let lastOption: OptionDef | null = null;
            attribute.options.forEach((option) => {
                if (optionIds.findIndex((optionId) => optionId === option.id) !== -1) {
                    option.disabled = false;
                    lastOption = option;
                    ++count;
                } else {
                    option.disabled = true;
                }
            });
            attribute.restrictVersion = restrictVersion;
            if (!attribute.value) {
                if (count > 0) {
                    attribute.disabled = false;
                    attribute.isComplete = false;
                } else {
                    attribute.disabled = true;
                    attribute.isComplete = true;
                }
            }
            if (count > 0) {
                attribute.hasSingleOption = (count === 1 && !attribute.isValueByUser ? lastOption : null);
            } else {
                attribute.hasSingleOption = null;
            }
            const page = state.pages.find((p) => p.n === attribute.pageN);
            if (page) {
                let isAutoComplete = true;
                page.attributes.forEach((a) => {
                    if (!(a.disabled || a.hasSingleOption)) {
                        isAutoComplete = false;
                    }
                });
                page.isAutoComplete = isAutoComplete;
            }
            updateProgress(state);
        },

        forceRestrictVersion(state) {
            ++state.restrictVersion;
        },

        updateProductsCount(state, { productsCount }: { productsCount: boolean }) {
            state.productsCount = Number(productsCount);
            updateProgress(state);
        },

    },
    actions: {
        async init({commit}) {
            return $.get('./api/setup.json').then((data) => {
                // set translations
                data.messages.trans = {
                    ... FIXMEtranslations[i18n.locale],
                    ... data.messages.trans,
                };
                i18n.setLocaleMessage(i18n.locale, data.messages);

                initPages(data);
                commit('init', data);
            }, (jqXHR, textStatus, errorThrown ) => {
                return Promise.reject(textStatus || errorThrown);
            });
        },

        async activatePage({commit, state}, { n }: { n: number }) {
            const page = state.pages.find((p) => p.n === n);
            if (n === 0 || (page && (page.isEnabled || state.productsCount === 1))) {
                commit('activatePage', { n });
                return store.dispatch('computeOptionsOnPage', { attribute: null});
            } else {
                return Promise.reject();
            }
        },

        async product({commit}, payload: { product: ProductDef | null}) {
            commit('product', payload);
        },

        async productForOrder({commit}, payload: { product: ProductDef}) {
            commit('productForOrder', payload);
        },

        async addCompareProduct({commit, state}, payload: { product: ProductDef}) {
            commit('addCompareProduct', payload);
        },

        async removeCompareProduct({commit, state}, payload: { product: ProductDef}) {
            commit('removeCompareProduct', payload);
        },

        async order(
            {commit},
            {customer, product, consentMessage}:
                { customer: CustomerDef, product: ProductDef, consentMessage: string},
        ) {
            commit('order', {customer, product});
            return $.post({
                url: './api/order.json',
                data: JSON.stringify({
                    customer,
                    product,
                    consentMessage,
                }),
                contentType: 'application/json',
            }).then((data) => {
                return Promise.resolve();
            }, (jqXHR, textStatus, errorThrown ) => {
                // FIXME error handling
                return Promise.reject(textStatus || errorThrown);
            });
            // return Promise.reject('not implemented yet'); // FIXME not implemented yet
        },

        async setAttribute(
            {commit, state},
            { attribute, value, disabled, isValueByUser, isComplete, preventCompute }:
                {
                    attribute: AttributeDef,
                    value: string,
                    disabled: boolean,
                    isValueByUser: boolean,
                    isComplete: boolean | undefined,
                    preventCompute: boolean | undefined,
                },
        ) {
            commit('setAttribute', {
                attribute, value,
                disabled: !!disabled,
                isValueByUser: !!isValueByUser,
                isComplete,
            });
            if (!preventCompute) {
                return store.dispatch('computeOptionsOnPage', { attribute });
            }
        },

        async resetAll({commit, state}) {
            commit('forceRestrictVersion');
            state.attributes.forEach((attr, index) => {
                commit('setAttribute', { attribute: attr, value: '', disabled: true, isValueByUser: false});
            });
            commit('activatePage', { n: 1 });
            return store.dispatch('computeOptionsOnPage', { attribute: null});
        },

        async computeOptionsOnPage({commit, state}, { attribute, page }:
            { attribute: AttributeDef, page: PageDef | null },
        ) {
            const restrictVersion = state.restrictVersion;
            const targets: AttributeDef[] = [];
            const selected: { [key: string]: string } = {};

            if (!page) {
                page = state.page;
            }

            state.attributes.forEach((attr, index) => {
                if (attr.isComplete && attr.value && attr.isValueByUser) {
                    selected[attr.id] = attr.value;
                }
                if (page && attr.pageN === page.n &&
                    attr.restrictVersion !== restrictVersion &&
                    attr !== attribute) {
                    targets.push(attr);
                }
            });
            if (!targets.length) {
                return;
            }

            targets.forEach( (target) => {
                commit('setIndicator', { attribute: target, indicator: true});
            });

            const myRippleCounter = ++rippleCounter;
            return restrictMultiCall({
                selected,
                query: targets.map( (target) => target.id),
                dataSetId: store.state.dataSetId,
            }).then((data) => {
                if (data.success === false && data.dataSetId !== store.state.dataSetId) {
                    alert(i18n.t('trans.reloadingDueToDataChange'));
                    location.reload();
                    return;
                }
                const worklist: Array<() => Promise<any> > = [];
                const attributeOptionIds = data.attributeOptionIds;
                targets.forEach( (target) => {
                    commit('updateSelect', {
                        attribute: target,
                        optionIds: attributeOptionIds[target.id],
                        restrictVersion,
                    });
                    commit('setIndicator', { attribute: target, indicator: false});
                    const enabledOptions = target.options.filter(
                        (option: OptionDef) => option.disabled === false,
                    );
                    if (enabledOptions.length === 1) {
                        worklist.push( () => {
                            if (myRippleCounter === rippleCounter) {
                                return store.dispatch('setAttribute', {
                                    attribute: target,
                                    value: enabledOptions[0].id,
                                    isValueByUser: target.isValueByUser,
                                    preventCompute: true,
                                });
                            }
                            return Promise.resolve();
                        });
                    } else if (enabledOptions.length === 0) {
                        worklist.push( () => {
                            if (myRippleCounter === rippleCounter) {
                                return store.dispatch('setAttribute', {
                                    attribute: target,
                                    value: '',
                                    isComplete: true,
                                    disabled: true,
                                    preventCompute: true,
                                });
                            }
                            return Promise.resolve();
                        });
                    }
                });
                if (data.product) {
                    if (data.product.accessoryTables) {
                        data.product.accessoryTables.forEach((accessoryTable: AccessoryTableDef) => {
                            accessoryTable.entries.forEach((entry) => {
                                entry.isSelected = false;
                            });
                        });
                    }
                }
                commit('product', { product: data.product || null });
                commit('updateProductsCount', { productsCount: data.productsCount } );
                return Promise.all(worklist.map( (f) => f())).then(
                    () => {
                        if (page && page.isComplete) {
                            const pageNextN = page.n + 1;
                            const pageNext = state.pages.find((p) => p.n === pageNextN);
                            if (pageNext) {
                                return store.dispatch('computeOptionsOnPage', { attribute: null, page: pageNext });
                            }
                        }
                    },
                );
            }, (jqXHR, textStatus, errorThrown ) => {
                targets.forEach( (target) => {
                    commit('setIndicator', { attribute: target, indicator: false});
                });
                // FIXME error handling
                return Promise.reject(textStatus || errorThrown);
            });
        },
    },
};

const store = new Vuex.Store<AppState>(storeOption);
export default store;

// FIXME where to put this? someting like global.d.ts

export declare interface StepDef {
    n: number;
    label: string;
    location: RouterLocation;
    isActive: boolean;
    isEnabled: boolean;
}

export declare interface PageDef extends StepDef {
    isComplete: boolean;
    isAutoComplete: boolean;
    attributes: AttributeDef[];
}

export declare interface AttributeDef {
    id: string;
    label: string;
    value: string;
    isComplete: boolean;
    hasSingleOption: OptionDef | null;
    options: OptionDef[];
    index: number;
    disabled: boolean;
    indicator: boolean;
    pageN: number;
    restrictVersion: number;
    isValueByUser: boolean;
}

export declare interface OptionDef {
    id: string;
    label: string;
    disabled: boolean;
    name: string;
    articleNo: string | null;
    subtitle: string | null;
    description: string | null;
    features: string | null;
    accessoryTable: string | null;
    image: string | null;
    datasheet: string | null;
}

export declare interface ProductDef {
    id: string;
    name: string;
    articleNo: string | null;
    subtitle: string | null;
    description: string | null;
    features: string | null;
    accessoryTables: AccessoryTableDef[]| null;
    image: string | null;
    datasheet: string | null;
    status: string | null;
    link: string | null;
    options: { [key: string]: string };
}

export declare interface AccessoryTableDef {
    key: string;
    entries: AccessoryTableEntryDef[];
}

export declare interface AccessoryTableEntryDef {
    rowType: string;
    label: string;
    articleNo?: string;
    isSelected?: boolean;
}

export declare interface CustomerDef {
    company: string;
    department: string;
    firstname: string;
    lastname: string;
    streetAddress: string;
    zip: string;
    city: string;
    country: string;
    phone: string;
    fax: string;
    mailAddress: string;
}

export declare interface AppState {
    dataSetId: string;
    pages: PageDef[];
    page: PageDef | null;
    maxPage: PageDef | null;
    progress: number;
    productsCount: number;
    product: ProductDef | null;
    productForOrder: ProductDef | null;
    compare: ProductDef[];
    customer: CustomerDef | null;
    attributes: AttributeDef[];
    ajaxModal: boolean;
    mode: string;
    flags: { [key: string]: boolean };
    restrictVersion: number;
}
